import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import { Dialog, DialogContent, Grid, DialogActions, Typography, DialogTitle, Divider, } from "@material-ui/core";
export const ContactAODialog = ({ isDialogOpen, onDialogClose, caseId, }) => {
    return (React.createElement(Dialog, { open: isDialogOpen, onClose: () => {
            onDialogClose();
        }, maxWidth: "md", fullWidth: true },
        React.createElement(DialogTitle, null, "Contact AO"),
        React.createElement(Divider, null),
        React.createElement(DialogContent, null,
            React.createElement(Grid, { container: true, spacing: 3 },
                React.createElement(Grid, { item: true, xs: 12, sm: 12 },
                    React.createElement(Fragment, null,
                        React.createElement(Typography, { variant: "body1" }, "This link will open up another browser tab for you to add a new Contact AO record. When you have sent the Contact AO request, please copy the reference from the address bar and add it to a new case note, in the complaints record."))))),
        React.createElement(DialogActions, null,
            React.createElement(Link, { target: "_blank", to: "/contactao/add", className: "linkButton", "data-test": "contact-ao-link" }, "Contact AO"))));
};
